<div class="app-container" [class.is-mobile]="mobileQuery.matches">
  <mat-toolbar color="primary" class="app-toolbar">
    <div class="app-toolbar-sections">
      <!-- Start: Hamburger + Title -->
      <div class="app-toolbar-start">
        <button mat-icon-button (click)="mainSideNav.toggle()"><mat-icon>menu</mat-icon></button>
        <span class="app-toolbar-title" i18n="@@Batch Order">Batch Order</span>
      </div>

      <!-- End -->
      <div class="app-toolbar-end">
        <app-active-role></app-active-role>
      </div>
    </div>
  </mat-toolbar>

  <mat-sidenav-container class="app-sidenav-container" (backdropClick)="mainSideNav.close()" [style.marginTop.px]="mobileQuery.matches ? 56 : 0">
    <mat-sidenav opened #mainSideNav [mode]="mobileQuery.matches ? 'over' : 'side'" (keydown.escape)="mainSideNav.close()" [fixedInViewport]="mobileQuery.matches" fixedTopGap="56">
      <mat-nav-list>
        <app-side-nav focus="csv"></app-side-nav>
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content class="m2app-dark">
      <ng-container *ngIf="csvEcommerceConnection">
        <app-csv-page [ecommerceConnection]="csvEcommerceConnection"></app-csv-page>
      </ng-container>
      <ng-container *ngIf="!csvEcommerceConnection">
        <div i18n="@@Create an Ecommerce Connection to enable the ability to create batch orders by uploading a CSV file.">Create an Ecommerce Connection to enable the ability to create batch orders by uploading a CSV file.</div>
      </ng-container>

    </mat-sidenav-content>
  </mat-sidenav-container>
</div>






